module.exports = __webpack_public_path__ + "img/icon-support-phone.f0de9305.svg";